// removed by extract-text-webpack-plugin
module.exports = {"title":"order-header--title--GV0-AlLj","order-number":"order-header--order-number--G6nB3m_W","orderNumber":"order-header--order-number--G6nB3m_W","box-icon":"order-header--box-icon--1LyO4zCr","boxIcon":"order-header--box-icon--1LyO4zCr","modify-order":"order-header--modify-order--1lovRQi8","modifyOrder":"order-header--modify-order--1lovRQi8","order-info":"order-header--order-info--2x6KSlqq","orderInfo":"order-header--order-info--2x6KSlqq"};


//////////////////
// WEBPACK FOOTER
// ./components/order-header/styles.css
// module id = ./components/order-header/styles.css
// module chunks = 0